import { useState } from "react";

import { Add as AddIcon } from "@mui/icons-material";

import AddOrgazinationTeamModal from "../../../Modals/AddOrgazinationTeamModal";

const EventOrgazinationTeamAdd = (props) => {
  const { onUpdate } = props;
  const [addTeam, setAddTeam] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setAddTeam(true);
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
      >
        <AddIcon className="m-r-5" /> Add Member
      </button>
      {addTeam && (
        <AddOrgazinationTeamModal
          open={addTeam}
          onClose={() => {
            setAddTeam(false);
          }}
          onUpdate={() => {
            setAddTeam(false);
            onUpdate();
          }}
        />
      )}
    </>
  );
};

export default EventOrgazinationTeamAdd;
